import React, { useContext, useState } from 'react'
import { AuthFetch } from '../services/api'
import { UserContext} from '../context/provider/UserProvider'

const urlBaseDashboard = process.env.REACT_APP_TMAN_API + '/Dashboard'

export const useDashboars = () => {
    const { stateUser , signOut } = useContext(UserContext);
    const codEmpresa = stateUser.codEmpresa
    
    const [unidadesEnMantenimiento,setUnidadesEnMantenimiento] = useState([])
    const [otPorMes,setOtPorMes]  = useState([])
    const [otPorEstado,setOtPorEstado] = useState([])
    const [repuestosSinStock,setRepuestosSinStock] = useState([])
    const [cantidadBimsSinAtender,setCantidadBimsSinAtender] = useState(0)
    const [unidadesConMasBims,setUnidadesConMasBims] = useState([])


    const listarUnidadesEnMantenimiento = async () => {
        const response = await AuthFetch({
            url: urlBaseDashboard + '/UnidadesEnMantenimiento?' + new URLSearchParams({
                codEmpresa: codEmpresa
            })
        })
        if(response.isValid){
            setUnidadesEnMantenimiento(response.content)
        }
    }

    const listarOTPorMes = async () => {
        const response = await AuthFetch({
            url: urlBaseDashboard + '/OTPorMes?' + new URLSearchParams({
                codEmpresa: codEmpresa
            })
        })
        if(response.isValid){
            setOtPorMes(response.content)
        }
    }

    const listarOTPorEstado = async () => {
        const response = await AuthFetch({
            url: urlBaseDashboard + '/OTPorEstado?' + new URLSearchParams({
                codEmpresa: codEmpresa
            })
        })
        if(response.isValid){
            setOtPorEstado(response.content)
        }
    }

    const listarRepuestosSinStock = async () => {
        const response = await AuthFetch({
            url: urlBaseDashboard + '/RepuestosSinStock?' + new URLSearchParams({
                codEmpresa: codEmpresa
            })
        })
        if(response.isValid){
            setRepuestosSinStock(response.content)
        }
    }

    const obtenerBimsSinAtender = async () => {
        const response = await AuthFetch({
            url: urlBaseDashboard + '/BimsSinAtender?' + new URLSearchParams({
                codEmpresa: codEmpresa
            })
        })
        if(response.isValid){
            setCantidadBimsSinAtender(response.content.bimSinAtender)
        }
    }

    const listartUnidadesConMasBims = async () => {
        const response = await AuthFetch({
            url: urlBaseDashboard + '/UnidadesConMasBims?' + new URLSearchParams({
                codEmpresa: codEmpresa
            })
        })
        if(response.isValid){
            setUnidadesConMasBims(response.content)
        }
    }
    
    return {
        listarUnidadesEnMantenimiento,
        unidadesEnMantenimiento,
        listarOTPorMes,
        otPorMes,
        listarOTPorEstado,
        otPorEstado,
        listarRepuestosSinStock,
        repuestosSinStock,
        obtenerBimsSinAtender,
        cantidadBimsSinAtender,
        listartUnidadesConMasBims,
        unidadesConMasBims
    }
}
